// src/Home.js
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../../assets/logo.png"; // 👈 image path

function Home() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/AdminLogin"); // 👈 navigate to Login page
    }, 2000);

    return () => clearTimeout(timer); // cleanup
  }, [navigate]);

  return (
    <div style={styles.container}>
      <img src={logo} alt="Centered" style={styles.image} />
    </div>
  );
}

const styles = {
  container: {
    height: "100vh",
    width: "100vw",
    backgroundColor: "#6F70FA",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  image: {
    maxWidth: "300px",
    width: "100%",
    height: "200",
  },
};

export default Home;
